import React from "react";
import "./Loading.css";

function Loader() {
  return (
    <div className="asdf" role="status">
      <div className="loading">
        <div className="spinner" />
        <h3>Cargando...</h3>
      </div>
    </div>
  );
}

export default Loader;
